module.exports = __webpack_public_path__ + "img/map-marker-alt-solid.2b7c48a7.svg";